<div class="cc-map-container">
  <div #mapDiv class="cc-map" [style.height]="mapheight"></div>
</div>
